import { Injectable } from '@angular/core';

import { NavigationLogger, NavigationLogEntry } from './navigation-logger';

/**
 * The only sink in this feature (FR-037): one console.info entry per
 * navigation. AITH-38 replaces it without touching call sites.
 */
@Injectable()
export class ConsoleNavigationLogger extends NavigationLogger {
  logNavigation(entry: NavigationLogEntry): void {
    console.info('[navigation]', entry);
  }
}
